import React from "react";
import Skeleton from "@/components/feedback/Skeleton";
import Visibility from "@/components/shared/Visibility";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { SkeletonImageProps } from "./types";

function SkeletonImage({
  isLoaded,
  className,
  children,
  ...props
}: SkeletonImageProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div className="relative w-full h-full">
      <Visibility shouldShow={!isLoaded}>
        <Skeleton
          className={cn("absolute inset-0", className, classes)}
          {...native}
        />
      </Visibility>

      {children}
    </div>
  );
}
export default SkeletonImage;
